import { render } from "./LoadingAnimation.vue?vue&type=template&id=225de83c&scoped=true&lang=pug"
import script from "./LoadingAnimation.vue?vue&type=script&setup=true&lang=js"
export * from "./LoadingAnimation.vue?vue&type=script&setup=true&lang=js"

import "./LoadingAnimation.vue?vue&type=style&index=0&id=225de83c&scoped=true&lang=sass"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-225de83c"]])

export default __exports__